import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import '@/css/styles.css';
import router from '@/router'
import { loadMessages } from '@progress/kendo-vue-intl'
import kendoDaDK from '@/localization/kendo-da-DK'
import 'moment/locale/da'
import 'moment/locale/de'
import 'moment/locale/sv'

loadMessages(kendoDaDK, 'da-DK')

const pinia = createPinia();

createApp(App)
    .use(pinia)
    .use(router)
    .mount('#app')
